module.exports = __webpack_public_path__ + "img/sala_do_empreendedor_prata.ddd596b0.png";